"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyDB = void 0;
function createEmptyDB(defaultSubQuestionType) {
    return {
        defaultSubQuestionType: defaultSubQuestionType,
        questions: {},
        lists: {
            root: {
                lid: 'root',
                idx: 0,
                childQIds: [],
            },
        },
    };
}
exports.createEmptyDB = createEmptyDB;
exports.default = createEmptyDB;
